// src/components/data/DataContext.js
import { createContext, useContext } from 'react';

export const DataContext = createContext({});

// Convenience hook
export const useInitialData = () => useContext(DataContext);
